import React, { useState } from 'react';
import styled from 'styled-components';
import { IoIosClose } from 'react-icons/io';
import 'react-datepicker/dist/react-datepicker.css';
import { inputNumberAutoComma, timeValueToDate } from '../../lib/commonFunc/commonFunc';
import PointInfoModal from './PointInfoModal';
import { pointTitle, pointMemo } from '../../lib/pointLabel';
import palette from '../../lib/styles/palette';
import {
  FiAlertCircle
} from 'react-icons/fi';

const FullScreen = styled.div`
  cursor: default;
  position: fixed;
  z-index: 30;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const PointForm = styled.form`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-bottom: 0;
  margin-right: -18px;
  padding-right: 18px;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${palette.webGray[4]};
    border-radius: 10px;
    background-clip: padding-box;
    border: 2px solid transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: ${palette.webGray[2]};
    border-radius: 10px;
  }
`;

const Seperator = styled.div`
  position: relative;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & + & { border-top: 1px solid #f2f4f7; }
`;
const InfoIcon = styled.div`
	position: absolute;
	cursor: pointer;
	left: 65px;
	top: 13px;
`;

const Space = styled.div`
  height: 0.8rem;
`;

const StyledLabel = styled.label`
  margin-right: 20px;
  padding: 5px 0;
`;

const HeroPoint = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f4f8ff 0%, #e8f0ff 100%);
  border: 1px solid #d6e2ff;
  border-radius: 12px;
  padding: 18px 22px;
  margin: 6px 0 18px;
  span.h-label { font-size: .95rem; font-weight: 700; color: #5b6b8c; }
  span.h-val { font-size: 1.85rem; font-weight: 800; color: ${palette.webCyan[5]}; letter-spacing: -0.5px; }
`;
const MainLabel = styled.label`
  text-align: left;
  font-size: 1.05rem;
  font-weight: 700;
  color: #2c3e50;
  flex: 1;
`;
const MainValueLabel = styled.label`
  font-size: 1.15rem;
  font-weight: 800;
  color: ${palette.webCyan[5]};
`;
const SubLabel = styled.label`
  text-align: left;
  font-size: .95rem;
  color: #868e96;
  font-weight: 500;
  flex: 1;
`;
const SubLabelButton = styled.label`
  font-size: .95rem;
  color: #868e96;
  font-weight: 500;
`;
const SubValueLabel = styled.label`
  text-align: right;
  font-size: .98rem;
  font-weight: 600;
  color: #3a4656;
`;
const SubFixLabel = styled.label`
  text-align: left;
  font-size: .95rem;
  font-weight: 500;
  color: #868e96;
  width: 200px;
`;
const NameLabel = styled.label`
  font-size: 1.4rem;
  font-weight: 800;
  color: #222;
  text-align: left;
  display: block;
  margin-bottom: 8px;
`;
const Line10 = styled.div`
  height: 1px;
  margin: 20px 0;
  background: #e0e4ea;
`;
const Line1 = styled.div`
  height: 1px;
  margin: 12px 0;
  background: #eef0f3;
`;


const AskModalBlock = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 540px;
    max-width: 92vw;
    background: #fff;
    padding: 28px 30px;
    border-radius: 16px;
    max-height: 86vh;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);

    @media screen and (max-width: 720px) {
        position: absolute;
        top: 100px;
    }
`;
const CloseBlock = styled.div`
    position: absolute;
    top: 22px;
    right: 24px;

    & svg{
        cursor: pointer;
        font-size: 1.9rem !important;
        color: #b0b8c4;
    }
    & svg:hover { color: #6b7280; }
`;

const PointModal = ({
  visible,
  onClose,
  data,
	user,
	setPointModal,
}) => {
    const [modals, setModals] = useState([
      {
        id: 'pointinfo',
        visible: false,
      }
    ]);
    const getDecreaseTypeString = (useData)=>{
        // 로스터 구매(110 꾸미기 · 111 캐릭터 · 112 의상) — 러닝앱·트랩앱과 같은 제목 + 메모(「캐릭터 · 의상」).
        //   예전엔 이 분류가 없어 빈칸이었고, 옛 행 메모는 내부 키(locker:outfit:1:w04_s03)라 보여 주지 않는다.
        if (useData.fcType >= 110 && useData.fcType <= 112) {
            const memo = pointMemo(useData);
            return memo ? `${pointTitle(useData)} · ${memo}` : pointTitle(useData);
        }
        switch (useData.fcType) {
            case 0:
                return useData.memo?useData.memo:'이벤트';
            case 102:
                return '회원권';
            case 103:
                return useData.memo?`락커 - ${useData.memo}`:'락커';
            case 104:
                return '일반 상품';
            default:
                return '';
        }
    }
    const onCloseInfoModal = ()=>{
        setModals((modals) =>
            modals.map((modal) =>
            modal.id === 'pointinfo' ? { ...modal, visible: false } : modal,
            ),
        );
    }
    const onOpenInfoModal = ()=>{
        setModals((modals) =>
            modals.map((modal) =>
            modal.id === 'pointinfo' ? { ...modal, visible: true } : modal,
            ),
        );
    }
  if (!visible || !data) return null;
  return (
    <FullScreen>
        <PointInfoModal
            onClose={onCloseInfoModal}
            visible={modals[0].visible}
            data={data}
        />
      <AskModalBlock>
        <CloseBlock onClick={() => setPointModal(false)}>
          <IoIosClose />
        </CloseBlock>
        <NameLabel>{user && user.name} {'포인트'}</NameLabel>
        <PointForm>
            <Space/>
            <HeroPoint>
                <span className="h-label">현재 보유 포인트</span>
                <span className="h-val">{inputNumberAutoComma(data.increaseTotal - data.decreaseTotal)}원</span>
            </HeroPoint>
            <Seperator>
                <SubLabel>총 획득 포인트</SubLabel>
                <SubValueLabel>{inputNumberAutoComma(data.increaseTotal)}원</SubValueLabel>
            </Seperator>
            <Seperator>
                <SubLabel>총 사용 포인트</SubLabel>
                <SubValueLabel>{inputNumberAutoComma(data.decreaseTotal)}원</SubValueLabel>
            </Seperator>
            <Line10/>
            <Seperator>
                <MainLabel>획득 포인트 내역</MainLabel>
                <MainValueLabel>{inputNumberAutoComma(data.increaseTotal)}원</MainValueLabel>
            </Seperator>
            <Seperator>
                <SubLabelButton>이벤트</SubLabelButton>
                <InfoIcon>
                    <FiAlertCircle onClick={onOpenInfoModal}/>
                </InfoIcon>
                <SubValueLabel>{data && data.infos && inputNumberAutoComma(data.infos.reduce((total, dd) => {

                    if(dd.action == 1 && (dd.fcType == 0 || dd.fcType == 102 || dd.fcType == 103 || dd.fcType == 104))
                    {
                        return total + dd.point;
                    }
                    return total;
                    }, 0))}원
                </SubValueLabel>
            </Seperator>
            <Seperator>
                <SubLabel>클럽등록</SubLabel>
                <SubValueLabel>{inputNumberAutoComma(data.infos.reduce((total, dd) => {

                    if(dd.action == 1 && dd.fcType == 100)
                    {
                        return total + dd.point;
                    }
                    return total;
                    }, 0))}원
                </SubValueLabel>
            </Seperator>
            <Seperator>
                <SubLabel>출석</SubLabel>
                <SubValueLabel>{inputNumberAutoComma(data.infos.reduce((total, dd) => {

                    if(dd.action == 1 && dd.fcType == 101)
                    {
                        return total + dd.point;
                    }
                    return total;
                    }, 0))}원
                </SubValueLabel>
            </Seperator>
            <Line1/>
            {
                data.infos.reduce((total, dd) => {

                    if(dd.action == 1 && dd.fcType == 1)
                    {
                        return total + dd.point;
                    }
                    return total;
                }, 0) > 0 &&
                <Seperator>
                    <SubLabel>런닝</SubLabel>
                    <SubValueLabel>{inputNumberAutoComma(data.infos.reduce((total, dd) => {

                        if(dd.action == 1 && dd.fcType == 1)
                        {
                            return total + dd.point;
                        }
                        return total;
                        }, 0))}원
                    </SubValueLabel>
                </Seperator>
            }
            {
                data.infos.reduce((total, dd) => {

                    if(dd.action == 1 && dd.fcType == 3)
                    {
                        return total + dd.point;
                    }
                    return total;
                }, 0) > 0 &&
                <Seperator>
                    <SubLabel>웨이트</SubLabel>
                    <SubValueLabel>{inputNumberAutoComma(data.infos.reduce((total, dd) => {

                        if(dd.action == 1 && dd.fcType == 3)
                        {
                            return total + dd.point;
                        }
                        return total;
                        }, 0))}원
                    </SubValueLabel>
                </Seperator>
            }
            {
                data.infos.reduce((total, dd) => {

                    if(dd.action == 1 && dd.fcType == 2)
                    {
                        return total + dd.point;
                    }
                    return total;
                }, 0) > 0 &&
                <Seperator>
                    <SubLabel>싸이클/기타</SubLabel>
                    <SubValueLabel>{inputNumberAutoComma(data.infos.reduce((total, dd) => {

                        if(dd.action == 1 && dd.fcType == 2)
                        {
                            return total + dd.point;
                        }
                        return total;
                        }, 0))}원
                    </SubValueLabel>
                </Seperator>
            }
            <Line10/>
            <Seperator>
                <MainLabel>사용 포인트 내역</MainLabel>
                <MainValueLabel>{inputNumberAutoComma(data.decreaseTotal)}원</MainValueLabel>
            </Seperator>
            {
                data.infos.map((useData, index)=>{
                    if(useData.action == 1)
                    {
                        return null;
                    }

                    return (
                        <Seperator key={index}>
                            <SubFixLabel>{getDecreaseTypeString(useData)}</SubFixLabel>
                            <SubLabel>{timeValueToDate(useData.registTime)}</SubLabel>
                            <SubValueLabel>{inputNumberAutoComma(useData.point)}원</SubValueLabel>
                        </Seperator>
                    )
                })
            }
        </PointForm>
      </AskModalBlock>
    </FullScreen>
  );
};

export default PointModal;
